import script from "./test.vue?vue&type=script&setup=true&lang=js"
export * from "./test.vue?vue&type=script&setup=true&lang=js"

import "./test.vue?vue&type=style&index=0&id=427f70e0&lang=css"

const __exports__ = script;

export default __exports__